<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-building fa-fw"></i>Empresas
          </h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="pull-right">
          <a
            class="btn btn-default"
            @click="
              addButton.seeForm = !addButton.seeForm;
              person = {};
            "
          >
            <span v-if="addButton.seeForm">
              <i class="fa fa-search fa-fw"></i>Buscar
            </span>
            <span v-else> <i class="fa fa-plus fa-fw"></i> Adicionar </span>
          </a>

          <a
            class="btn btn-primary"
            @click="
              downloadReport();
            "
          >
            <span> <i class="fa fa-file-pdf-o fa-fw"></i> Relátorio Empresas Credenciadas </span>
          </a>
          <br />
          <br />
          <br />
        </div>

        <div class="col-lg-12">
          <div v-if="addButton.seeForm">
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation" class="active">
                <a
                  href="#home"
                  aria-controls="home"
                  role="tab"
                  data-toggle="tab"
                >
                  <i class="fa fa-user fa-fw"></i> Dados Cadastrais</a
                >
              </li>
              <li role="presentation">
                <a
                  data-js="activities-tab"
                  href="#activities"
                  aria-controls="profile"
                  role="tab"
                  data-toggle="tab"
                >
                  <i class="fa fa-rocket fa-fw"></i>
                  Atividades</a
                >
              </li>
            </ul>
          
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="home">
                <form role="form" @submit.stop.prevent="send">
                  <h2><i class="fa fa-home fa-fw"></i> Empresa</h2>
                  <div class="form-row">
                    <div class="col-md-4 mb-3">
                      <label>ID</label>
                      <input
                        v-model="person.id"
                        class="form-control"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Nome (Razão Social)</label>
                      <input
                        v-model="person.name"
                        class="form-control"
                        placeholder="Nome"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Nome Fantasia</label>
                      <input
                        v-model="person.corporateName"
                        class="form-control"
                        placeholder="Nome fantasia"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>CNPJ</label>
                      <input
                        v-model="person.cnpj"
                        class="form-control"
                        v-mask="'##.###.###/####-###'"
                        placeholder="XX.XXX.XXX/XXXX-XXX"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Inscrição Estadual</label>
                      <input
                        v-model="person.stateRegistration"
                        class="form-control"
                        placeholder="Inscrição Estadual"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Endereço da Sede - Logradouro</label>
                      <input
                        v-model="person.primaryAddress"
                        class="form-control"
                        placeholder="Endereço"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Nº</label>
                      <input
                        v-model="person.primaryAddressNumber"
                        class="form-control"
                        placeholder="Número"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Bairro</label>
                      <input
                        v-model="person.primaryAdressDistrict"
                        class="form-control"
                        placeholder="Bairro"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Complemento</label>
                      <input
                        v-model="person.primaryAdressComplement"
                        class="form-control"
                        placeholder="Complemento"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>CEP</label>
                      <input
                        v-model="person.primaryPostalCode"
                        class="form-control"
                        v-mask="'##.###-###'"
                        placeholder="CEP"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Cidade</label>
                      <input
                        v-model="person.municipalRegistration"
                        class="form-control"
                        placeholder="Cidade"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>UF</label>
                      <input
                        v-model="person.primaryAdressState"
                        class="form-control"
                        placeholder="UF"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Telefone</label>
                      <input
                        v-model="person.primaryPhone"
                        class="form-control"
                        v-mask="'(##) ####-####'"
                        placeholder="(DD) XXXX-XXXX"
                        disabled
                      />
                    </div>
                    <div class="col-md-8 mb-3">
                      <label>Email</label>
                      <input
                        v-model="person.primaryEmail"
                        class="form-control"
                        placeholder="exemplo@exemplo.com"
                        disabled
                      />
                      <p
                        v-if="!validarEmail(person.primaryEmail)"
                        style="color: red"
                      >
                        <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                      </p>
                    </div>
                  </div>
                  <p>&nbsp</p>
                  <!-- 
                  <h2><i class="fa fa-database fa-fw"></i> Dados Filial</h2>
                  <div class="form-row">
                    <div class="col-md-8 mb-3">
                      <label>Endereço da Filial</label>
                      <input
                        v-model="person.secundaryAddress"
                        class="form-control"
                        placeholder="Endereço da filial"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Nº</label>
                      <input
                        v-model="person.secundaryAddressNumber"
                        class="form-control"
                        placeholder="Número da filial"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Bairro</label>
                      <input
                        v-model="person.secundaryAdressDistrict"
                        class="form-control"
                        placeholder="Bairro da filial"
                        disabled
                      />
                    </div>
                    <div class="col-md-8 mb-3">
                      <label>Complemento</label>
                      <input
                        v-model="person.secundaryAdressComplement"
                        class="form-control"
                        placeholder="Complemento da filial"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>CEP</label>
                      <input
                        v-model="person.secundaryPostalCode"
                        class="form-control"
                        v-mask="'##.###-###'"
                        placeholder="CEP da filial"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Cidade</label>
                      <input
                        class="form-control"
                        placeholder="Cidade da filial"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>UF</label>
                      <input
                        v-model="person.secundaryAdressState"
                        class="form-control"
                        placeholder="UF da filial"
                        disabled
                      />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label>Telefone</label>
                      <input
                        v-model="person.secundaryPhone"
                        class="form-control"
                        v-mask="'(##) ####-####'"
                        placeholder="(DD) XXXX-XXXX da filial"
                        disabled
                      />
                    </div>
                    <div class="col-md-8 mb-3">
                      <label>Email</label>
                      <input
                        v-model="person.secundaryEmail"
                        class="form-control"
                        placeholder="exemplo@exemplo.com"
                        disabled
                      />
                      <p
                        v-if="!validarEmail(person.secundaryEmail)"
                        style="color: red"
                      >
                        <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                      </p>
                    </div>
                  </div>
                  -->
                  <p>&nbsp</p>
                  <h2><i class="fa fa-users"></i> Responsáveis</h2>
                  <div class="form-row">
                    <div class="col-md-6 mb-3">
                      <label>Representante Legal</label>
                      <input
                        v-model="person.legalRepresentativeName"
                        class="form-control"
                        placeholder="Nome"
                        disabled
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>CPF</label>
                      <input
                        v-model="person.legalRepresentativeCPF"
                        class="form-control"
                        v-mask="'###.###.###-##'"
                        placeholder="CPF"
                        disabled
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>Cargo</label>
                      <input
                        v-model="person.legalRepresentativeCargo"
                        class="form-control"
                        placeholder="Cargo"
                        disabled
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>Telefone Cel</label>
                      <input
                        v-model="person.legalRepresentativePhone"
                        class="form-control"
                        v-mask="'(##) # ####-####'"
                        placeholder="(DD) X XXXX-XXXX"
                        disabled
                      />
                    </div>
                    <div class="col-md-12 mb-3">
                      <label>Email</label>
                      <input
                        v-model="person.legalRepresentativeEmail"
                        class="form-control"
                        placeholder="exemplo@exemplo.com"
                        disabled
                      />
                      <p
                        v-if="!validarEmail(person.legalRepresentativeEmail)"
                        style="color: red"
                      >
                        <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                      </p>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>Representante Técnico</label>
                      <input
                        v-model="person.tecnicalRepresentativeName"
                        class="form-control"
                        placeholder="Nome"
                        disabled
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>CPF</label>
                      <input
                        v-model="person.tecnicalRepresentativeCPF"
                        class="form-control"
                        v-mask="'###.###.###-##'"
                        placeholder="CPF"
                        disabled
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>Cargo</label>
                      <input
                        v-model="person.tecnicalRepresentativeCargo"
                        class="form-control"
                        placeholder="Cargo"
                        disabled
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>Telefone Cel</label>
                      <input
                        v-model="person.tecnicalRepresentativePhone"
                        class="form-control"
                        v-mask="'(##) # ####-####'"
                        placeholder="(DD) X XXXX-XXXX"
                        disabled
                      />
                    </div>
                    <div class="col-md-12 mb-3">
                      <label>Email</label>
                      <input
                        v-model="person.tecnicalRepresentativeEmail"
                        class="form-control"
                        placeholder="exemplo@exemplo.com"
                        disabled
                      />
                      <p
                        v-if="!validarEmail(person.tecnicalRepresentativeEmail)"
                        style="color: red"
                      >
                        <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                      </p>
                    </div>
                  </div>
                  <p>&nbsp</p>
              

              <h2><i class="fa fa-pencil fa-fw"></i> Termos de Uso</h2>

              <div class="panel panel-default">
                <div class="panel-heading">DECLARAÇÃO DE RESPONSABILIDADE</div>
                <div class="panel-body">
                  <p>
                    <b v-if="person.name">{{ person.name }}</b
                    ><b v-else>{{ person.legalRepresentativeName }}</b
                    >, <b v-if="person.cnpj">{{ person.cnpj }}</b
                    ><b v-else>{{ person.legalRepresentativeCPF }}</b> declara
                    ter pleno conhecimento e ser total responsável pelo estrito
                    cumprimento da legislação ambiental e da segurança do
                    trabalho e pela adoção de todos os procedimentos de saúde,
                    de segurança, de meio ambiente e operacionais dentro da área
                    do Porto Organizado do Itaqui, e que, portanto, assume a
                    responsabilidade, na esfera cível ou criminal, por eventuais
                    incidentes que vierem a decorrer de descumprimento do
                    ordenamento jurídico vigente.
                  </p>
                </div>
              </div>

              <div class="panel panel-default">
                <div class="panel-heading">
                  TERMO DE CONSENTIMENTO PARA TRATAMENTO DE DADOS PESSOAIS
                </div>
                <div class="panel-body">
                  <p>
                    (Este termo de consentimento fundamenta-se no art. 7º, I da
                    Lei n.º 13.709, de 2018 e servirá de base legal para a
                    coleta de dado pessoal por ocasião do cadastro no sistema
                    Passport e inserção de informações no site do Porto do
                    Itaqui)
                  </p>

                  <p>
                    Em observância à Lei n.º 13.709, de 2018 (Lei Geral de
                    Proteção de Dados), manifesto-me de forma livre, expressa,
                    consciente e informada para AUTORIZAR a Empresa Maranhense
                    de Administração Portuária (EMAP) a realizar o tratamento de
                    meus dados pessoais para as finalidades e de acordo com as
                    condições aqui estabelecidas.
                  </p>

                  <p>
                    1. Finalidade do Tratamento. Os dados pessoais serão
                    coletados pela Gerência de Logística da EMAP e serão
                    utilizados, exclusivamente, para as seguintes finalidades:
                    coleta e inserção de dados (nome da empresa, endereço,
                    telefone e e-mail) no site do Porto do Itaqui.
                  </p>

                  <p>
                    2. Prazo de Retenção. Os dados pessoais coletados serão
                    armazenados em banco de dados virtual da EMAP e divulgados
                    no site do Porto do Itaqui pelo prazo de 03 anos.
                  </p>

                  <p>
                    3. Revogação do Consentimento. Este termo de consentimento
                    poderá ser revogado pelo Titular, mediante solicitação
                    enviada pelo Canal de Atendimento de Privacidade de dados,
                    no endereço https://www.portodoitaqui.ma.gov.br/contato,
                    podendo exercer os demais direitos previstos no Art. 17 e
                    seguintes da LGPD, através do mesmo Canal.
                  </p>
                </div>
              </div>

                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      disabled
                      v-model="person.confirmation"
                      v-bind:id="person.confirmation"
                    />
                    <label class="form-check-label" for="check-hab">
                      Ciente
                    </label>
                  </div>
                  <p>&nbsp</p>
                      <p class="float-righ">
                    <small>
                      cadastro {{ person.created | formatDate }}, atualizado em
                      {{ person.updated | formatDate }}</small
                    >
                  </p>
                  <div class="row">
                    <div class="col-12">
                      <button type="submit" class="btn btn-block btn-info">
                        Salvar
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div role="tabpanel" class="tab-pane" id="activities">
                <div class="container">
                  <br />
                  <div class="panel-group" id="accordion">
                    <div
                      class="panel panel-default"
                      v-for="atividade in activities"
                      :key="atividade.id"
                    >
                      <div class="panel-heading">
                        <h4 class="panel-title">
                          <a
                            class="accordion-toggle"
                            data-toggle="collapse"
                            data-parent="#accordion"
                            :data-js="atividade.id"
                            v-bind:href="'#atividade' + atividade.id"
                            @click="loadAccreditation(atividade)"
                          >
                            {{ atividade.name }}
                            <small v-if="atividade.accreditation">
                              <!-- <div
                                class="label label-info"
                                style="padding: 6px; margin: 3px"
                              >
                                {{
                                  atividade.accreditation.state ||
                                  "em andamento"
                                }}
                              </div>

                              <a
                                class="btn btn-xs btn-info"
                                v-if="
                                  atividade.accreditation.state == 'liberado'
                                "
                                @click.prevent.stop="
                                  downloadCertificate(person.id, atividade.id)
                                "
                                style="margin: 5px"
                              >
                                <i class="fa fa-download fa-fw"></i>
                                download certificado
                              </a>
                            -->
                              <a
                                class="btn btn-xs btn-danger"
                                v-if="atividade.accreditation && canDeleteAccreditation()"
                                @click.prevent.stop="
                                  deleteAccreditation(atividade, $event)
                                "
                                style="margin: 5px"
                              >
                                  remover
                              </a> 

                              <a
                                class="btn btn-xs btn-info"
                                v-if="
                                  atividade.accreditation.state == 'liberado'
                                "
                                @click.prevent.stop="
                                  downloadCertificate(person.id, atividade.id)
                                "
                                style="margin: 5px"
                              >
                                <i class="fa fa-download fa-fw"></i>
                                download certificado
                              </a>

                              <div
                                class="label label-info"
                                style="padding: 6px; margin: 3px"
                              >
                                {{
                                  atividade.accreditation.state || 'emAnalise'
                                }}
                              </div>

                            </small>
                          </a>
                        </h4>
                      </div>
                      <div
                        :id="'atividade' + atividade.id"
                        class="panel-collapse collapse"
                      >
                        <div class="panel-body">
                          <h4><i class="fa fa-book fa-fw"></i> Descrição</h4>

                          <p>
                            <b>{{ atividade.description }} </b>
                          </p>
                          <form
                            @submit.stop.prevent="
                              sendAccreditation(person, atividade)
                            "
                          >
                            <input type="hidden" v-model="accreditation.id" />
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Nº do certificado</label>
                                  <input
                                    class="form-control"
                                    v-model="numeroProcesso"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="form-group">
                              <label>Descrição Detalhada: Descrever a atividade que será realizada na área primária conforme consta na Comprovação de Inscrição de Situação Cadastral (CNPJ)</label>
                              <textarea
                                maxlength="250"
                                class="form-control"
                                v-model="accreditation.details"
                              ></textarea>
                            </div>

                            <div class="form-group">
                              <button
                                type="submit"
                                class="btn btn-block btn-info"
                                @click="alert = true"
                              >
                                <i class="fa fa-send fa-fw"></i> Salvar e começar a enviar documentos
                              </button>
                            </div>
                          </form>
                          <div
                            v-if="alert"
                            class="alert alert-success col-lg-12"
                          >
                            <i class="fa fa-info fa-fw"></i>
                            <span>
                              <strong>
                                Sua solicitação de credenciamento foi solicitada
                                com sucesso, por favor envie todos os documentos
                                necessários para a análise!
                              </strong>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="alert"
                                aria-label="Close"
                                @click="alert = null"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </span>
                          </div>
                          <hr />

                          <h4><i class="fa fa-file-o fa-fw"></i> Documentos</h4>

                          <div
                            class="panel panel-info"
                            v-for="item in itens"
                            :key="item.rule.id"
                            v-show="documentIsVisible(item)"
                          >
                            <div class="panel-heading">
                              <div class="panel-title">
                                {{ item.rule.name }}
                              </div>
                            </div>

                            <div class="panel-body">
                              <form class="form-inline">
                                <div class="form-group col-md-6">
                                  <file-pond
                                    name="file"
                                    ref="pond"
                                    label-idle="Faça upload do documento aqui"
                                    v-bind:allow-multiple="false"
                                    accepted-file-types="application/pdf, application/zip"
                                    v-bind:server="
                                      loadServerData(
                                        accreditation || null,
                                        person.id,
                                        atividade,
                                        item.rule.id,
                                        item.rule.filename
                                      )
                                    "
                                  />
                                </div>
                                <div class="form-group">
                                  <label>Validade</label>
                                  <input
                                    type="text"
                                    class="form-control input-sm"
                                    size="10"
                                    v-mask="'##/##/####'"
                                    :value="dataFormatada(item.validity)"
                                    placeholder="DD/MM/AAAA"
                                    name="validade"
                                    id="validade"
                                    :disabled="!item.rule.expirationRequired"
                                    @blur="
                                      sendValidade(
                                        $event,
                                        accreditation.id,
                                        item.rule.id
                                      )
                                    "
                                  />
                                </div>
                                <div
                                  class="btn-group btn-group-sm pull-right"
                                  role="group"
                                >
                                  <div class="btn-group btn-group-sm">
                                    <a
                                      type="button"
                                      class="btn dropdown-toggle"
                                      :class="getState(item.state)"
                                      data-toggle="dropdown"
                                    >
                                      <i
                                        class="fa"
                                        :class="getIcon(item.state)"
                                      ></i>
                                      {{ item.state }}
                                      <span class="caret"></span>
                                    </a>
                                    <ul class="dropdown-menu">
                                      <li>
                                        <a
                                          href="#"
                                          @click.prevent.stop="(show = item.rule.id),(showModal = 7), (action = 'valido')"
                                        >
                                          <i class="fa fa-check"></i> validar</a
                                        >
                                      </li>
                                      <li>
                                        <a
                                          href="#"
                                          @click.prevent.stop="(show = item.rule.id),(showModal = 7), (action='recusado')"
                                        >
                                          <i class="fa fa-times"></i> recusar</a
                                        >
                                      </li>
                                    </ul>
                                    <Modal
                                      v-if="showModal === 7 && show === item.rule.id"
                                    >
                                      <i
                                        slot="close"
                                        @click="
                                          showModal = null;
                                          show = null;
                                        "
                                        >&times;</i
                                      >
                                      <h2 slot="header">
                                        <i class="fa fa-send"></i>
                                        Motivo
                                      </h2>
                                      <div slot="body">
                                        <textarea
                                          maxlength="250"
                                          class="form-control"
                                          v-model="comment"
                                          type="text"
                                          required
                                          rows="6"
                                          style="width: 563px"
                                          placeholder="Informe o motivo"
                                        >
                                        </textarea>
                                      </div>
                                      <div slot="footer">
                                        <button
                                          class="btn btn-default"
                                          @click="
                                            showModal = null;
                                            show = null;
                                          "
                                        >
                                          Cancelar
                                        </button>
                                        <button
                                          class="btn btn-primary"
                                          @click.prevent.stop="updateState(atividade,accreditation.id,item.rule.id,action)"
                                          @click="
                                            showModal = null;
                                            show = null;
                                          "
                                        >
                                          <i class="fa fa-send"></i>
                                          Enviar Motivo
                                        </button>
                                      </div>
                                    </Modal>
                                  </div>
                                  <a
                                    class="btn btn-info"
                                    @click="
                                      download(
                                        person.id,
                                        atividade.id,
                                        item.rule.id,
                                        item.rule.filename
                                      )
                                    "
                                  >
                                    <i class="fa fa-download fa-fw"></i>
                                    download
                                  </a>
                                  <a
                                    class="btn btn-warning"
                                    @click="
                                      preview(
                                        person.id,
                                        atividade.id,
                                        item.rule.id,
                                        item.rule.filename
                                      )
                                    "
                                  >
                                    <i class="fa fa-file-o fa-fw"></i>
                                    visualizar
                                  </a>
                                  <a
                                    type="button"
                                    class="btn btn-warning"
                                    @click="
                                      (show = item.rule.id), (showModal = 6)
                                    "
                                    @click.stop="showHistory(item.id)"
                                  >
                                    <i class="fa fa-clock-o fa-fw"></i>
                                    historico
                                  </a>
                                  <Modal
                                    v-if="
                                      showModal === 6 && show === item.rule.id
                                    "
                                  >
                                    <i
                                      slot="close"
                                      @click="
                                        showModal = null;
                                        show = null;
                                      "
                                      >&times;</i
                                    >
                                    <h2 slot="header">
                                      <i class="fa fa-clock-o fa-fw"></i
                                      >Histórico
                                    </h2>
                                    <div slot="body">
                                      <table
                                        class="
                                          table
                                          table-bordered
                                          table-striped
                                          table-hover
                                        "
                                        v-if="historico.length"
                                      >
                                        <thead>
                                          <tr>
                                            <th>Situação</th>
                                            <th>Usuário</th>
                                            <th>Data de Atualização</th>
                                            <th>Motivo da recusa</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            v-for="history in historico"
                                            :key="history.id"
                                          >
                                            <td
                                              class="alert"
                                              :class="getAlert(history.state)"
                                            >
                                              <span>{{ history.state }}</span>
                                            </td>
                                            <td>{{ history.user.nome }}</td>
                                            <td>{{ history.updated | formatDate }}
                                            </td>
                                            <td>{{ history.reason }}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <div v-else class="alert alert-danger">
                                        <i class="fa fa-exclamation"></i>
                                        Nenhum registro encontrado
                                      </div>
                                    </div>
                                    <div slot="footer">
                                      <button
                                        class="btn btn-default"
                                        @click.prevent.stop="
                                          showModal = null;
                                          show = null;
                                        "
                                      >
                                        fechar
                                      </button>
                                    </div>
                                  </Modal>
                                </div>
                              </form>
                              <span
                                v-if="
                                  item.refusedReason && item.state == 'recusado'
                                "
                              >
                                <br />
                                <br />
                                <div class="alert alert-danger">
                                  <i class="fa fa-times"></i>
                                  <b>Motivo da recusa</b> <br />
                                  {{ item.refusedReason }}
                                </div>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <form>
              <div class="form-group">
                <input
                  v-model="search"
                  class="form-control"
                  placeholder="Buscar..."
                  @keyup="busca(search)"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div v-if="filtred.length && !addButton.seeForm">
          <table class="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Razão Social</th>
                <th>Nome Fantasia</th>
                <th>Email do Representante Legal</th>
                <th>Email da Empresa</th>
                <th>Telefone</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="person in filtred"
                :key="person.id"
                @mouseover="showByIndex = person.id"
                @mouseout="showByIndex = null"
              >
                <td>{{ person.id }}</td>
                <td>{{ person.name }}</td>
                <td>{{ person.corporateName }}</td>
                <td>{{ person.legalRepresentativeEmail }}</td>
                <td>{{ person.primaryEmail }}</td>
                <td>{{ person.primaryPhone }}</td>
                <td>
                  <a
                    @click.stop="edit(person.id)"
                    v-visible="showByIndex === person.id"
                    class="btn btn-sm btn-primary"
                    ><i class="fa fa-pencil fa-fw"></i
                  ></a>
                  <a
                    @click="
                      showModal = 2;
                      show = person.id;
                    "
                    v-visible="showByIndex === person.id"
                    class="btn btn-sm btn-danger"
                    ><i class="fa fa-trash fa-fw"></i
                  ></a>
                  <a
                    style="display: none"
                    @click="
                      showModal = 1;
                      show = showByIndex;
                    "
                    v-visible="showByIndex === person.id"
                    type="button"
                    class="btn btn-sm btn-info"
                    ><i class="fa fa-rocket fa-fw"></i
                  ></a>
                  <Modal v-if="showModal === 1 && show === person.id">
                    <i slot="close" @click="showModal = null">&times;</i>

                    <span slot="header">
                      <h3>
                        <i class="fa fa-rocket fa-fw"></i>
                        Adicionar Atividades
                      </h3>
                      <small
                        >Depois de selecionar as atividades. Vá em
                        <router-link
                          class="btn btn-info btn-sm"
                          to="/admin/activity"
                          >atividades</router-link
                        >
                        e envie os documentos necessários</small
                      >
                    </span>

                    <div slot="body" v-if="activities.length">
                      <div class="row">
                        <div
                          class="col-md-4"
                          v-for="activity in activities"
                          :key="activity.id"
                        >
                          <div class="panel panel-info">
                            <div class="panel-heading">
                              <small class="panel-title">
                                #{{ activity.id }}
                              </small>
                            </div>
                            <div class="panel-body" style="max-height: 100px">
                              <small>{{ activity.name }}</small>
                              <br />
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-bind:id="activity.id"
                                v-model="activity.enabled"
                                :checked="false"
                              />
                              <label
                                class="form-check-label"
                                v-bind:for="activity.id"
                              >
                                Adicionar
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div slot="footer">
                      <button class="btn btn-default" @click="showModal = null">
                        fechar
                      </button>
                    </div>
                  </Modal>
                  <Modal v-if="showModal === 2 && show === person.id">
                    <i
                      slot="close"
                      @click="
                        showModal = null;
                        yes = null;
                      "
                      >&times;</i
                    >
                    <h2 slot="header">
                      <i class="fa fa-times fa-fw"></i>Remover Empresa
                    </h2>
                    <div slot="body">
                      <h4>
                        Deseja realmente remover a empresa
                        <strong>{{ person.name }}?</strong>
                      </h4>
                    </div>
                    <div slot="footer">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="
                          yes = true;
                          showModal = null;
                        "
                        @click.stop="remove(person.id)"
                      >
                        Confirmar
                      </button>
                      <button
                        class="btn btn-default"
                        @click="
                          yes = null;
                          showModal = null;
                        "
                      >
                        fechar
                      </button>
                    </div>
                  </Modal>
                </td>
              </tr>
            </tbody>
          </table>
          <nav aria-label="Page navigation" style="text-align: center">
            <ul class="pagination">
              <li>
                <a
                  href="#"
                  @click.prevent.stop="goToPage(pageable.pageNumber - 1)"
                >
                  <span> &laquo; Anterior</span>
                </a>
              </li>
              <li>
                <a href="#">{{ pageable.pageNumber + 1 }}/{{ totalPages }}</a>
              </li>
              <li v-if="pageable.pageNumber === totalPages">
                <a href="#">
                  <span>Proxima &raquo; </span>
                </a>
              </li>
              <li v-else>
                <a
                  href="#"
                  @click.prevent.stop="goToPage(pageable.pageNumber + 1)"
                >
                  <span>Proxima &raquo; </span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <Modal v-if="showModal === 3">
          <i slot="close" @click="showModal = null">&times;</i>
          <h2 slot="header">
            <i class="fa fa-times fa-fw"></i>Verifique os campos
          </h2>
          <div slot="body">
            <div
              v-for="error in msg"
              :key="error.indexOf"
              class="alert alert-danger alert-small"
            >
              {{ error }}
            </div>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = null">
              Ok
            </button>
          </div>
        </Modal>
        <Modal v-if="showModal === 4">
          <i slot="close" @click="showModal = null">&times;</i>
          <h2 slot="header">
            <i class="fa fa-exclamation-circle fa-fw"></i>Cadastro de Empresa
          </h2>
          <div slot="body">
            <div class="alert alert-success alert-small">
              <i class="fa fa-exclamation"></i>
              Empresa cadastrada com sucesso!
            </div>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = null">
              Ok
            </button>
          </div>
        </Modal>
        <Modal v-if="showModal === 5">
          <i slot="close" @click="showModal = null">&times;</i>
          <h2 slot="header">
            <i class="fa fa-times fa-fw"></i>Exclusão de Empresa
          </h2>
          <div slot="body">
            <div class="alert alert-success alert-small">
              <i class="fa fa-exclamation"></i>
              Empresa excluída com sucesso!
            </div>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = null">
              Ok
            </button>
          </div>
        </Modal>
        <div v-else-if="!filtred.length">
          <div class="alert alert-info">
            <p>
              <i class="fa fa-exclamation fa-fw"></i>Nenhum registro foi
              encontrado
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>

<script>
import vueFilePond, { setOptions } from "vue-filepond";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import ptBR from "filepond/locale/pt-br";
import "filepond/dist/filepond.css";
import { mask } from "vue-the-mask";
import Modal from "../../components/ui-elements/Modal.vue";
import lang from "../../mixins/pt-br";
import storage from "../../mixins/storage";
import stateMix from "../../mixins/state";

const FilePond = vueFilePond(FilePondPluginFileValidateType);
setOptions(ptBR);
export default {
  name: "Person",
  directives: { mask },
  inject: ["loading"],
  components: { Modal, FilePond },
  data() {
    return {
      action : '',
      comment: "",
      config: {},
      search: "",
      addButton: { seeForm: false },
      person: {},
      persons: [],
      activity: {},
      activities: [],
      accreditations: [],
      itens: [],
      accreditation: {},
      showByIndex: null,
      showModal: null,
      yes: null,
      show: null,
      msg: null,
      alert: null,
      pageable: {},
      totalPages: null,
      totalElements: null,
      size: null,
      historico: [],
      files: [
        {
          source: "12345",
          options: {
            type: "local",
            file: {
              name: `${this.$http.defaults.baseURL}`,
              size: 3001025,
              type: "application/pdf",
            },
          },
        },
      ],
      server: {
        url: this.$http.defaults.baseURL,
        process: {
          url: "/config/upload",
          method: "POST",
          withCredentials: false,
          headers: {
            Authorization: `Bearer ${storage.methods.getToken()}`,
          },
          timeout: 250000,
          onload: null,
          onerror: null,
          ondata: null,
        },
      },
    };
  },
  mounted() {
    this.$http.get(`/config`).then((response) => {
      this.config = response.data;

      this.goToPage();
      this.busca();

      if (this.$route.query.edit) {
        this.loading.value = true;
        setTimeout(() => {
          this.edit(this.$route.query.edit);

          if (this.$route.query.activity) {
            this.loading.value = true;
            setTimeout(
              () => this.showActivity(this.$route.query.activity),
              1000
            );
          }
        }, 1000);
      }
    });
  },
  methods: {
    canDeleteAccreditation(){
      return this.config.sectorId === storage.methods.getUser().sectorId

    },
    showActivity(activityId) {
      const activitiesTab = document.querySelector(
        '[data-js="activities-tab"]'
      );
      activitiesTab.click();

      const selectedActivity = document.querySelector(
        `[data-js="${activityId}"]`
      );
      selectedActivity.click();
    },
    downloadCertificate(personId, activityId) {
      this.$http
        .get(
          `/certificate/get-certificate-by-person-and-activity/${personId}/${activityId}`
        )
        .then((response) => {
          window
            .open(`/#/certificate/print/${response.data.id}`, "_blank")
            .focus();
        })
        .catch((error) => console.log(error));
    },
    showHistory(item) {
      this.$http
        .get(`/history/${item}`)
        .then((response) => {
          this.historico = response.data;
        })
        .catch((error) => console.log(error));
    },
    documentIsVisible(item) {
      return (
        item.rule.sectorId == storage.methods.getUser().sectorId ||
        (this.config.allowAdminsManageFiles &&
          storage.methods.getUser().sectorId == this.config.sectorId)
      );
    },
    handleFilePondInit(person, atividade, rule, filename) {
      console.log(person, atividade, rule, filename);
    },
    getIcon(stateName) {
      return stateMix.methods.getIcon(stateName);
    },
    getState(stateName) {
      return stateMix.methods.getState(stateName);
    },
    getAlert(stateName) {
      return stateMix.methods.getAlert(stateName);
    },
    sendValidade(event, accreditation, rule) {
      const data = event.target.value;
      const validity = data.split("/").reverse().join("-");

      this.$http
        .put(
          `/my-accreditation-itens/validity/${accreditation}/${rule}/${validity}`
        )
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => console.log(error));
    },
    updateState(atividade, accreditationId, ruleId, state) {
      this.loading.value = true;

      let comment = this.comment.length
        ? this.comment
        : "sem informações adicionais";

      this.$http
        .put(
          `/accreditation-itens/update-state/${accreditationId}/${ruleId}/${state}`,
          { comment: comment }
        )
        .then((response) => {

          this.$http
            .put(
              `/accreditation-itens/refused-reason/${accreditationId}/${ruleId}`,
              { comment: comment }
            )
            .then((response) => {
              this.comment = "";
            })
            .catch((error) => console.log(error));


          this.loadAccreditation(atividade);
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setTimeout(() => (this.loading.value = false), 1000);
        });
    },
    dataFormatada(data) {
      return data ? new Date(data).toLocaleDateString("pt-BR") : "";
    },
    sendAccreditation(person, atividade) {
      this.accreditation.personId = person.id;
      this.accreditation.activityId = atividade.id;

      if (!this.accreditation.id) {
        this.$http
          .post("my-accreditation", this.accreditation)
          .then((response) => {
            this.accreditation = response.data;
          })
          .finally(() => {
            atividade.accreditation = this.accreditation;
            this.loadAccreditation(atividade);
          })
          .catch((error) => console.log(error));
      } else {
        this.$http
          .put(`my-accreditation/${this.accreditation.id}`, this.accreditation)
          .then((response) => {
            this.accreditation = response.data;
          })
          .finally(() => {
            atividade.accreditation = this.accreditation;
            this.loadAccreditation(atividade);
          })
          .catch((error) => console.log(error));
      }
    },
    loadServerData(accreditation, person, activity, rule, filename) {
      if (!this.accreditation) {
        return;
      }

      const customUrl = `/my-accreditation/upload/${accreditation.id}/${person}/${activity.id}/${rule}/${filename}`;

      return {
        url: this.$http.defaults.baseURL,
        process: {
          url: customUrl,
          method: "POST",
          withCredentials: false,
          headers: {
            Authorization: `Bearer ${storage.methods.getToken()}`,
          },
          timeout: 7000,
          onload: () => {
            activity.accreditation = accreditation;
            this.loadAccreditation(activity);
          },
          onerror: null,
          ondata: null,
        },
      };
    },
    loadAccreditation(atividade) {
      this.loading.value = true;

      if (atividade.accreditation) {
        this.accreditation = atividade.accreditation;

        this.$http
          .get(`/accreditation-itens/all/${this.accreditation.id}`)
          .then((response) => {
            this.itens = response.data;
          })
          .catch((error) => console.log(error))
          .finally(() => {
            setTimeout(() => (this.loading.value = false), 1000);
          });
      } else {
        this.accreditation = {};
        this.itens = [];
        setTimeout(() => (this.loading.value = false), 1000);
      }
    },
    download(person, activity, accreditation, filename) {
      const link = `${this.$http.defaults.baseURL}/public/credenciamentos/${person}/${activity}/${accreditation}/${filename}`;

      this.$http
        .get(link, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          const extension =
            response.headers["content-type"] == "application/zip"
              ? ".zip"
              : ".pdf";

          link.setAttribute("download", `${filename}${extension}`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    preview(person, activity, accreditation, filename) {
      const link = `${this.$http.defaults.baseURL}/public/credenciamentos/${person}/${activity}/${accreditation}/${filename}`;

      this.$http
        .get(link, { responseType: "blob" })
        .then((response) => {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch((error) => console.log(error));
    },
    goToPage(page) {
      if (page == undefined) {
        page = 0;
      }

      this.$http.get(`person?page=${page}&orderBy=id`).then((response) => {
        this.loading.value = true;
        this.persons = response.data.content;
        this.pageable = response.data.pageable;
        this.totalPages = response.data.totalPages;
        this.totalElements = response.data.totalElements;
        this.size = response.data.size;
        if (this.pageable.pageNumber > this.totalPages) {
          this.pageable.pageNumber = this.totalPages;
        }
        this.$http
          .get("/activity/available")
          .then((response) => {
            this.activities = response.data;
          })
          .catch((error) => console.log(error))
          .finally(() => {
            console.log("gotopage");
            setTimeout(() => (this.loading.value = false), 1000);
          });
      });
    },
    busca(nome) {
      const queryString = nome ? `?name=${nome}` : "";
      this.$http
        .get(`person${queryString}`)
        .then((response) => {
          this.persons = response.data.content;
        })
        .catch((error) => console.log(error))
        .finally(() => console.log("busca"));
    },
    send() {
      this.loading.value = true;
      if (this.person.id) {
        this.$http
          .put(`/person/${this.person.id}`, this.person)
          .then((response) => {
            this.persons = this.persons.filter(
              (item) => item.id != this.person.id
            );
            this.persons.push(response.data);
            this.addButton.seeForm = false;
            this.showModal = 4;
          })
          .catch((error) => {
            if (error.response) {
              this.exibirErroValidacao(error.response.data);
            }
          });
      } else {
        this.$http
          .post("/person", this.person)
          .then((response) => {
            this.person = {};
            this.persons.push(response.data);
            this.addButton.seeForm = false;
            this.showModal = 4;
          })
          .catch((error) => {
            if (error.response) {
              this.exibirErroValidacao(error.response.data);
            }
          });
      }
      setTimeout(() => (this.loading.value = false), 1000);
    },
    edit(id) {
      this.loading.value = true;
      this.$http
        .get(`/person/${id}`)
        .then((response) => {
          this.addButton.seeForm = true;
          this.person = response.data;

          this.$http
            .get(`/accreditation/all/${this.person.id}`)
            .then((response) => {
              this.accreditations = response.data;

              this.$forceUpdate();

              this.accreditations.forEach((item) => {
                this.activities.forEach((activity, index) => {
                  if (activity.id === item.activity.id) {
                    this.activities[index].accreditation = item;
                    return;
                  }
                });
              });
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          if (error.response) {
            this.exibirErroValidacao(error.response.data);
          }
        })
        .finally(() => {
          console.log("edit");
          setTimeout(() => (this.loading.value = false), 1000);
        });
    },
    remove(id) {
      this.loading.value = true;
      const confirm = this.yes;

      if (confirm) {
        this.$http
          .delete(`/person/${id}`)
          .then((response) => {
            this.persons = this.persons.filter((item) => item.id != id);
            this.showModal = 5;
          })
          .catch((error) => alert(error));
      }
      setTimeout(() => (this.loading.value = false), 1000);
    },
    exibirErroValidacao(error) {
      const errors = error.reduce((acc, { campo, erro }) => {
        acc.push(`${lang.t(campo)} : ${erro}`);
        return acc;
      }, []);

      this.showModal = 3;
      this.msg = errors;
    },
    validarEmail(email) {
      if (!email) {
        return true;
      }

      return /(.+)@(.+){2,}\.(.+){2,}/.test(email);
    },
    deleteAccreditation(atividade, $event) {
      const confirmation = confirm(
        `Tem certeza que deseja REMOVER o processo de certificação? Essa operação é irreversível.`
      );

      if (!confirmation) {
        return;
      }

      this.$http
        .delete(`/accreditation/${atividade.accreditation.id}`)
        .then((response) => {
          if(response.status == 200){

            atividade.accreditation = null
            this.loadAccreditation(atividade)
              const statusLabel = $event.target.parentNode.querySelector('div.label')
              if(statusLabel){
                statusLabel.remove()
              } 

            $event.target.remove()

           }
        })
        .catch((error) => console.log(error));
    },

    downloadReport() {
      this.$http
      .get(`/person/gerarRelatorio`, {responseType: 'blob'})
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'relatorio.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => {
        console.error('Error fetching Excel file:', error);
      });
    },
  },
  computed: {
    numeroProcesso() {
      if (this.accreditation.id == undefined) {
        return "";
      }

      const date = new Date();
      const number = new String(this.accreditation.id).padStart(5, "0");
      this.accreditation.processNumber = `${number}/${date.getUTCFullYear()}`;
      return this.accreditation.processNumber;
    },
    filtred() {
      const search = this.search.toLowerCase().trim();
      let result = [];

      if (!search) {
        result = this.persons;
      }

      result = this.persons.filter((a) => {
        const field = a.name || "";

        return field.toLowerCase().indexOf(search) > -1;
      });
      if (this.alert) {
        setTimeout(() => (this.alert = false), 8000);
      }

      return result.sort((a, b) => b.id - a.id);
    },
    filtredAct() {
      const search = this.search.toLowerCase().trim();
      let result = [];

      if (!search) {
        result = this.activities;
      }

      result = this.activities.filter(
        (a) => a.name.toLowerCase().indexOf(search) > -1
      );

      return result.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.accordion-toggle {
  text-decoration: none;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Persons.vue